import {Component, OnDestroy, OnInit} from '@angular/core';
import {ResourceTypesService} from "../data/resource-types.service";
import {ResourcesService} from "../data/resources.service";
import {TokenService} from "../../../services/auth/token.service";
import {TranslateService} from "../../../services/multilingual/translate.service";
import {JBMToastsService} from "../../../components/JBM/Views/JBMToasts/JBMToasts.service";
import {Subscription} from 'rxjs';
import {JBMTableColumnDef} from '../../../components/JBM/JBMTable/JBMTable.component';
import {QueryHttpHelper, SearchColumnType} from '../../../components/JBM/Helpers/QueryHttpHelper';
import {JBMSelectOption} from '../../../components/JBM/Forms/JBMFormGroups/JBMSelect/JBMSelect.component';

@Component({
  selector: 'resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit, OnDestroy {
  userRights: any;
  types: any[]=[];
  types$: Subscription;
  typeOptions: JBMSelectOption[]=[]
  type_id: number;

  items: any[];
  columnDefs: JBMTableColumnDef[];
  language: string=this.TokenService.getLanguage();
  loading: boolean=false;

  items$: Subscription;
  count$: Subscription;

  queryHttpHelper: QueryHttpHelper;
  search: string='';

  createActive: boolean=false;
  description: string='';
  descriptionError: string='';
  descriptionTouched: boolean=false;
  descriptionUnique:boolean=true;
  code: string='';
  codeError: string='';
  codeTouched: boolean=false;
  codeUnique:boolean=true;
  editing: boolean=false;

  constructor(
      private ResourceTypesService: ResourceTypesService,
      private ResourcesService: ResourcesService,
      private TokenService: TokenService,
      private TranslateService: TranslateService,
      private JBMToastsService: JBMToastsService,
  ) { }

  ngOnInit(): void {
    this.userRights = this.TokenService.getRightsByName('resources');

    this.types$=this.ResourceTypesService.get().subscribe(
        (data: any)=> {
          this.types=data.data
          for(let type of data.data)
            this.typeOptions.push( { key: type.id.toString(), value: type.description } )
          if(data.data.length)
            this.type_id=data.data[0].id;

          this.getData(true)
        },
        (error)=>console.error(error),
    );

    this.queryHttpHelper = new QueryHttpHelper();
    this.queryHttpHelper.paginationProps.pageSize=15
    this.queryHttpHelper.setSortColumn('description');
    this.queryHttpHelper.addSearchColumn('description', SearchColumnType.string);
  }
  changeType(event: any): void {
    this.type_id=parseInt(event.target.value);
    this.getData(true);
  }
  getData(countRows:boolean=false) {
    this.loading=true;
    let params=this.queryHttpHelper.getHttpParams(false);
    this.items$=this.ResourcesService.get(this.type_id, params).subscribe(
        (data: any)=>this.items=data.data,
        (error)=>console.error(error),()=>{
          this.loading=false;

          // Set editmode to false for each item
          for(let item of this.items)
            item.editing=false;

          if(countRows) {
            let params=this.queryHttpHelper.getHttpParams(true);
            this.count$=this.ResourcesService.get(this.type_id, params).subscribe(
                (data: any)=>this.queryHttpHelper.paginationProps.itemCount = data.data,
                (error)=>console.error(error));
          }
        } );
  }
  pageChange(page) {
    this.queryHttpHelper.paginationProps.page=page;
    this.getData();
  }
  sortChange(event) {
    this.queryHttpHelper.setSortColumn(event.name, event.descending);
    this.getData();
  }
  searchChange(event) {
    let value=event.value;
    let minlength=event.minlength;
    value=value.length<minlength ? '' : value;
    if(this.queryHttpHelper.getSearchValue() != value) {
      this.queryHttpHelper.setSearchValue(value);
      this.getData(true);
    }
  }
  // Create item
  startCreate() {
    if(this.editing) this.cancelEditing();
    this.clearItemData();
    this.createActive=true;
  }
  createCancel() {
    this.createActive=false;
    this.clearItemData();
  }
  // Update item
  startEditing(id) {
    if(!this.userRights.AllowUpdate) return false;
    if(this.createActive) this.createCancel();
    for(let item of this.items)
      if(item.id===id) {
        if(item.editing) return false;  // Row alreay in edit mode
        item.editing=true;
      } else
        item.editing=false;
    this.editing=true;
    let data=this.getOriginalValues();
    this.code=data.code;
    this.codeTouched=false;
    this.codeUnique=true;
    this.description=data.description;
    this.descriptionTouched=false;
    this.descriptionUnique=true;
  }
  cancelEditing() {
    for(let item of this.items)
      item.editing=false;
    this.editing=false;
    this.clearItemData();
    this.getData(false);
  }
  onChangeCode() {
    this.codeTouched=true;
  }
  validateCode() {
    let value=this.code.trim();
    if(!value) this.codeError=this.TranslateService.GetTranslation('entity.requiredfield');
    return value!='';
  }
  onChangeDescription() {
    this.descriptionTouched=true;
  }
  validateDescription() {
    let value=this.description.trim();
    if(!value) this.descriptionError=this.TranslateService.GetTranslation('entity.requiredfield');
    return value!='';
  }
  // Save item data
  createItem() {
    this.getValues();
    let data={ id: 0, type: this.type_id, code: this.code, description: this.description }
    this.ResourcesService.create(data).subscribe(()=>{},error=>this.handleError(error),()=>this.afterSave())
  }
  updateItem() {
    this.getValues();
    let originalValues=this.getOriginalValues();
    if(originalValues.code===this.code && originalValues.description===this.description ) {
      // Nothing changed; pretend if it has been a successful update
      this.JBMToastsService.success( this.TranslateService.GetTranslation('ui.entity-saved'));
      this.cancelEditing();
      return false;
    }
    let data={ id: originalValues.id, code: this.code, description: this.description }
    this.ResourcesService.update(data).subscribe(()=>{},error=>this.handleError(error),()=>this.afterSave())
  }
  getValues() {
    this.code=this.code.trim();
    this.description=this.description.trim();
  }
  getOriginalValues() {
    for(let item of this.items)
      if(item.editing)
        return item;
    return null;
  }
  setItemData(id) {
    return { id: id, type: this.type_id, code: this.code, description: this.description }
  }
  clearItemData() {
    this.code='';
    this.codeTouched=false;
    this.description='';
    this.descriptionTouched=false;
  }
  handleError(error) {
    this.codeUnique=true;
    this.descriptionUnique=true;
    if(error=='code_not_unique') {
      this.codeUnique=false;
      this.codeError=this.TranslateService.GetTranslation('entity.code-not-unique');
    }
    if(error=='description_not_unique') {
      this.descriptionUnique=false;
      this.descriptionError=this.TranslateService.GetTranslation('entity.description-not-unique');
    }
  }
  afterSave() {
    this.JBMToastsService.success( this.TranslateService.GetTranslation('ui.entity-saved'));
    if(this.createActive) {
      this.createCancel();
      this.getData(true);
    }
    if(this.editing) this.cancelEditing();
  }
  remove(id: number) {
    this.ResourcesService.delete(id).subscribe(()=>{},error=>this.handleError(error),()=>this.afterRemove())
  }
  afterRemove() {
    this.JBMToastsService.success( this.TranslateService.GetTranslation('ui.entity-deleted'));
    this.getData(true);
  }
  ngOnDestroy() {
    // Clean up observable subscriptions to avoid memory leaks
    if(this.types$!=undefined) this.types$.unsubscribe();
    if(this.items$!=undefined) this.items$.unsubscribe();
    if(this.count$!=undefined) this.count$.unsubscribe();
  }
}
